import { ILocLinkifierModel } from '../filters/LocLinkifierFilter';
import { Module } from '../Module';
import { ErrorMessageHandler } from '../services/ErrorMessageHandler';
import { WindowLocationService } from '../services/WindowLocationService';

export interface ISignInErrorScope extends ng.IScope {
  errorMessages: ILocLinkifierModel[];
  tryAgain: () => void;
  redirectPath?: string;
  errorCode: string;
}

export interface ISignInErrorStateParams extends ng.ui.IStateParamsService {
  errorCode: number;
  redirectPath: string;
}

export class SignInErrorCtrl {

  public static $inject = [
    '$scope',
    '$location',
    'WindowLocationService',
    'ErrorMessageHandler'
  ];

  constructor(
    $scope: ISignInErrorScope,
    $location: ng.ILocationService,
    windowLocationService: WindowLocationService,
    errorMessageHandler: ErrorMessageHandler
  ) {
    // Coerse error code
    const errorCode: number = +$scope.errorCode;
    let redirectPath: string = $scope.redirectPath || '/';
    // Fix for TFSID:1092736: Add a '/' before the redirectPath to prevent external redirects using @.
    if (redirectPath[0] !== '/') {
      redirectPath = '/' + redirectPath;
    }

    $scope.tryAgain = () => {
      // Prevent redirect injection by appending the current host to the redirect
      const target = $location.protocol() + '://' + $location.host() + ':' + $location.port() + redirectPath;
      windowLocationService.navigateToWithoutAddingToHistory(target);
    };

    $scope.errorMessages = errorMessageHandler.getSignInErrorMessages(errorCode);
  }

}

Module.instance().controller('SignInErrorCtrl', SignInErrorCtrl);
